/* Slaapritueel theme scripts */
(function () {
  const T = window.theme || { routes: { cartAdd: '/cart/add', cartChange: '/cart/change' }, strings: {}, openDrawer: true };
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));

  /* Starry sky */
  function sky(canvas) {
    const ctx = canvas.getContext('2d');
    const still = matchMedia('(prefers-reduced-motion: reduce)').matches;
    let stars = [];
    const css = getComputedStyle(document.documentElement);
    const night = css.getPropertyValue('--night').trim() || '#0d1330';
    const cream = css.getPropertyValue('--cream').trim() || '#f2ead8';
    function size() {
      const dpr = window.devicePixelRatio || 1;
      canvas.width = canvas.offsetWidth * dpr;
      canvas.height = canvas.offsetHeight * dpr;
      stars = Array.from({ length: Math.round((canvas.width * canvas.height) / 9000) }, () => ({
        x: Math.random() * canvas.width, y: Math.random() * canvas.height,
        r: Math.random() * 1.3 * dpr + 0.2, p: Math.random() * 6.28
      }));
    }
    function draw(t) {
      const w = canvas.width, h = canvas.height;
      const g = ctx.createRadialGradient(w * 0.82, h * 0.2, 0, w * 0.82, h * 0.2, w * 0.5);
      g.addColorStop(0, 'rgba(138,116,214,.22)');
      g.addColorStop(1, 'rgba(13,19,48,0)');
      ctx.fillStyle = night; ctx.fillRect(0, 0, w, h);
      ctx.fillStyle = g; ctx.fillRect(0, 0, w, h);
      ctx.fillStyle = cream;
      for (const s of stars) {
        ctx.globalAlpha = 0.35 + 0.45 * Math.sin(s.p + t / 1400);
        ctx.beginPath(); ctx.arc(s.x, s.y, s.r, 0, 6.28); ctx.fill();
      }
      ctx.globalAlpha = 1;
      if (!still) requestAnimationFrame(draw);
    }
    size();
    addEventListener('resize', size);
    requestAnimationFrame(draw);
  }

  /* Cart drawer */
  const drawerSel = '[data-cart-drawer]';
  function openCart() {
    const d = $(drawerSel); if (!d) return false;
    d.classList.add('open');
    const scrim = $('[data-cart-scrim]'); if (scrim) scrim.hidden = false;
    const x = $('[data-close-cart]', d); if (x) x.focus();
    return true;
  }
  function closeCart() {
    const d = $(drawerSel); if (!d) return;
    d.classList.remove('open');
    const scrim = $('[data-cart-scrim]'); if (scrim) scrim.hidden = true;
  }
  function renderDrawer(html) {
    if (!html) return;
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const fresh = doc.querySelector(drawerSel);
    const current = $(drawerSel);
    if (!fresh || !current) return;
    const wasOpen = current.classList.contains('open');
    current.innerHTML = fresh.innerHTML;
    current.dataset.count = fresh.dataset.count;
    if (wasOpen) current.classList.add('open');
    $$('[data-cart-count]').forEach(el => (el.textContent = fresh.dataset.count));
  }
  async function post(url, body) {
    const res = await fetch(url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(Object.assign(body, { sections: 'cart-drawer', sections_url: window.location.pathname }))
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.description || data.message || T.strings.error);
    return data;
  }

  document.addEventListener('submit', async e => {
    const form = e.target.closest('[data-add-form]');
    if (!form) {
      if (e.target.closest('[data-filter-form]')) return; // normal GET submit
      return;
    }
    e.preventDefault();
    const btn = form.querySelector('[type="submit"]');
    const fd = new FormData(form);
    const id = Number(fd.get('id'));
    const quantity = Number(fd.get('quantity') || 1);
    const label = btn ? btn.textContent : '';
    if (btn) btn.disabled = true;
    try {
      const data = await post(T.routes.cartAdd, { items: [{ id, quantity }] });
      renderDrawer(data.sections && data.sections['cart-drawer']);
      if (btn) btn.textContent = T.strings.added || '✓';
      if (T.openDrawer) openCart();
    } catch (err) {
      if (btn) btn.textContent = err.message || T.strings.error;
    } finally {
      setTimeout(() => { if (btn) { btn.textContent = label; btn.disabled = false; } }, 1400);
    }
  });

  document.addEventListener('click', async e => {
    if (e.target.closest('[data-open-cart]')) {
      if (openCart()) e.preventDefault();
      return;
    }
    if (e.target.closest('[data-close-cart]') || e.target.closest('[data-cart-scrim]')) { closeCart(); return; }
    const ch = e.target.closest('[data-change]');
    if (ch) {
      const d = $(drawerSel); if (d) d.classList.add('busy');
      try {
        const data = await post(T.routes.cartChange, { id: ch.dataset.change, quantity: Number(ch.dataset.qty) });
        renderDrawer(data.sections && data.sections['cart-drawer']);
      } catch (err) { /* keep drawer as is */ }
      const d2 = $(drawerSel); if (d2) d2.classList.remove('busy');
      return;
    }
    const menu = e.target.closest('[data-menu-toggle]');
    if (menu) {
      const nav = document.getElementById(menu.getAttribute('aria-controls'));
      const open = menu.getAttribute('aria-expanded') === 'true';
      menu.setAttribute('aria-expanded', String(!open));
      if (nav) nav.hidden = open;
      return;
    }
    const thumb = e.target.closest('[data-thumb]');
    if (thumb) {
      const main = $('[data-main-image] img');
      if (main) { main.removeAttribute('srcset'); main.src = thumb.dataset.thumb; }
    }
  });

  document.addEventListener('keydown', e => { if (e.key === 'Escape') closeCart(); });

  document.addEventListener('change', e => {
    const sel = e.target.closest('[data-variant-select]');
    if (sel) {
      const opt = sel.selectedOptions[0];
      const price = $('[data-price] .price-now');
      if (price && opt && opt.dataset.price) price.textContent = opt.dataset.price;
      const url = new URL(window.location.href);
      url.searchParams.set('variant', sel.value);
      history.replaceState({}, '', url);
      const btn = $('[data-add-button]');
      if (btn) { btn.disabled = opt.disabled; btn.textContent = opt.disabled ? T.strings.soldOut : T.strings.addToCart; }
    }
    const filterForm = e.target.closest('[data-filter-form]');
    if (filterForm) filterForm.requestSubmit ? filterForm.requestSubmit() : filterForm.submit();
  });

  document.addEventListener('DOMContentLoaded', () => {
    $$('[data-sky]').forEach(sky);
    // Theme editor: keep the drawer usable when sections reload
    document.addEventListener('shopify:section:load', ev => { $$('[data-sky]', ev.target).forEach(sky); });
  });
})();
